"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./data-toolbar.css");

exports.default = {
  dataToolbar: 'pf-c-data-toolbar',
  dataToolbarContentSection: 'pf-c-data-toolbar__content-section',
  divider: 'pf-c-divider',
  dataToolbarGroup: 'pf-c-data-toolbar__group',
  dataToolbarItem: 'pf-c-data-toolbar__item',
  dataToolbarToggle: 'pf-c-data-toolbar__toggle',
  pagination: 'pf-c-pagination',
  dataToolbarContent: 'pf-c-data-toolbar__content',
  dataToolbarExpandableContent: 'pf-c-data-toolbar__expandable-content',
  chipGroup: 'pf-c-chip-group',
  button: 'pf-c-button',
  modifiers: {
    'vertical': 'pf-m-vertical',
    'buttonGroup': 'pf-m-button-group',
    'iconButtonGroup': 'pf-m-icon-button-group',
    'filterGroup': 'pf-m-filter-group',
    'toggleGroup': 'pf-m-toggle-group',
    'alignRight': 'pf-m-align-right',
    'separator': 'pf-m-separator',
    'overflowMenu': 'pf-m-overflow-menu',
    'bulkSelect': 'pf-m-bulk-select',
    'searchFilter': 'pf-m-search-filter',
    'chipGroup': 'pf-m-chip-group',
    'label': 'pf-m-label',
    'pagination': 'pf-m-pagination',
    'expanded': 'pf-m-expanded',
    'chipContainer': 'pf-m-chip-container',
    'plain': 'pf-m-plain',
    'show': 'pf-m-show',
    'showOnMd': 'pf-m-show-on-md',
    'showOnLg': 'pf-m-show-on-lg',
    'showOnXl': 'pf-m-show-on-xl',
    'showOn_2xl': 'pf-m-show-on-2xl',
    'alignLeft': 'pf-m-align-left',
    'hidden': 'pf-m-hidden',
    'visible': 'pf-m-visible',
    'alignRightOnMd': 'pf-m-align-right-on-md',
    'alignLeftOnMd': 'pf-m-align-left-on-md',
    'hiddenOnMd': 'pf-m-hidden-on-md',
    'visibleOnMd': 'pf-m-visible-on-md',
    'alignRightOnLg': 'pf-m-align-right-on-lg',
    'alignLeftOnLg': 'pf-m-align-left-on-lg',
    'hiddenOnLg': 'pf-m-hidden-on-lg',
    'visibleOnLg': 'pf-m-visible-on-lg',
    'alignRightOnXl': 'pf-m-align-right-on-xl',
    'alignLeftOnXl': 'pf-m-align-left-on-xl',
    'hiddenOnXl': 'pf-m-hidden-on-xl',
    'visibleOnXl': 'pf-m-visible-on-xl',
    'alignRightOn_2xl': 'pf-m-align-right-on-2xl',
    'alignLeftOn_2xl': 'pf-m-align-left-on-2xl',
    'hiddenOn_2xl': 'pf-m-hidden-on-2xl',
    'visibleOn_2xl': 'pf-m-visible-on-2xl',
    'spaceItemsNone': 'pf-m-space-items-none',
    'spaceItemsSm': 'pf-m-space-items-sm',
    'spaceItemsMd': 'pf-m-space-items-md',
    'spaceItemsLg': 'pf-m-space-items-lg',
    'spaceItemsNoneOnMd': 'pf-m-space-items-none-on-md',
    'spaceItemsSmOnMd': 'pf-m-space-items-sm-on-md',
    'spaceItemsMdOnMd': 'pf-m-space-items-md-on-md',
    'spaceItemsLgOnMd': 'pf-m-space-items-lg-on-md',
    'spaceItemsNoneOnLg': 'pf-m-space-items-none-on-lg',
    'spaceItemsSmOnLg': 'pf-m-space-items-sm-on-lg',
    'spaceItemsMdOnLg': 'pf-m-space-items-md-on-lg',
    'spaceItemsLgOnLg': 'pf-m-space-items-lg-on-lg',
    'spaceItemsNoneOnXl': 'pf-m-space-items-none-on-xl',
    'spaceItemsSmOnXl': 'pf-m-space-items-sm-on-xl',
    'spaceItemsMdOnXl': 'pf-m-space-items-md-on-xl',
    'spaceItemsLgOnXl': 'pf-m-space-items-lg-on-xl',
    'spaceItemsNoneOn_2xl': 'pf-m-space-items-none-on-2xl',
    'spaceItemsSmOn_2xl': 'pf-m-space-items-sm-on-2xl',
    'spaceItemsMdOn_2xl': 'pf-m-space-items-md-on-2xl',
    'spaceItemsLgOn_2xl': 'pf-m-space-items-lg-on-2xl',
    'spacerNone': 'pf-m-spacer-none',
    'spacerSm': 'pf-m-spacer-sm',
    'spacerMd': 'pf-m-spacer-md',
    'spacerLg': 'pf-m-spacer-lg',
    'spacerNoneOnMd': 'pf-m-spacer-none-on-md',
    'spacerSmOnMd': 'pf-m-spacer-sm-on-md',
    'spacerMdOnMd': 'pf-m-spacer-md-on-md',
    'spacerLgOnMd': 'pf-m-spacer-lg-on-md',
    'spacerNoneOnLg': 'pf-m-spacer-none-on-lg',
    'spacerSmOnLg': 'pf-m-spacer-sm-on-lg',
    'spacerMdOnLg': 'pf-m-spacer-md-on-lg',
    'spacerLgOnLg': 'pf-m-spacer-lg-on-lg',
    'spacerNoneOnXl': 'pf-m-spacer-none-on-xl',
    'spacerSmOnXl': 'pf-m-spacer-sm-on-xl',
    'spacerMdOnXl': 'pf-m-spacer-md-on-xl',
    'spacerLgOnXl': 'pf-m-spacer-lg-on-xl',
    'spacerNoneOn_2xl': 'pf-m-spacer-none-on-2xl',
    'spacerSmOn_2xl': 'pf-m-spacer-sm-on-2xl',
    'spacerMdOn_2xl': 'pf-m-spacer-md-on-2xl',
    'spacerLgOn_2xl': 'pf-m-spacer-lg-on-2xl'
  }
};